import React from "react";
import "./Hero.css";

const Hero: React.FC = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-background" aria-hidden="true">
        <div className="hero-mesh mesh-one"></div>
        <div className="hero-mesh mesh-two"></div>
        <div className="hero-grid"></div>
      </div>

      <div className="hero-inner">
        <div className="hero-copy">
          <span className="hero-eyebrow">Construction field operations</span>
          <h1>Control every snag, site update, and handover from one field operations platform.</h1>
          <p>
            Arqite gives construction teams a live workspace to capture issues, assign owners, track
            resolution, and produce client-ready reports without spreadsheets or scattered chats.
          </p>

          <div className="hero-actions">
            <a href="https://app.arqite.com" className="hero-btn primary split" target="_blank" rel="noopener noreferrer">
              <span>Login</span>
              <i aria-hidden="true">→</i>
            </a>
            <a href="#contact" className="hero-btn secondary">
              Book a Demo
            </a>
          </div>

          <div className="hero-proof" aria-label="Product proof points">
            <span>Mobile-first inspections</span>
            <span>Live issue ownership</span>
            <span>Client-ready handover reports</span>
          </div>
        </div>

        <div className="hero-product" aria-label="Arqite product interface preview">
          <div className="issue-board">
            <div className="board-header">
              <div>
                <span>Live Snag Board</span>
                <strong>Docklands Tower / Level 14</strong>
              </div>
              <em>87% resolved</em>
            </div>

            <div className="board-progress">
              <span style={{ width: "87%" }}></span>
            </div>

            <div className="issue-row priority">
              <span className="issue-tag">High</span>
              <div>
                <strong>Water ingress around balcony threshold</strong>
                <p>Assigned to facade team - evidence required</p>
              </div>
              <small>Due today</small>
            </div>

            <div className="issue-row">
              <span className="issue-tag medium">QA</span>
              <div>
                <strong>Paint finish defect in corridor C</strong>
                <p>Photo added from mobile inspection</p>
              </div>
              <small>Open</small>
            </div>

            <div className="board-footer">
              <div className="avatar-stack" aria-hidden="true">
                <span>PM</span>
                <span>QA</span>
                <span>FT</span>
              </div>
              <p>24 owners active across today's closeout list</p>
            </div>
          </div>

          <div className="floating-card evidence-card">
            <span>Photo evidence</span>
            <div className="photo-strip">
              <i></i>
              <i></i>
              <i></i>
            </div>
            <strong>37 uploads synced</strong>
          </div>

          <div className="floating-card report-card">
            <span>Handover pack</span>
            <strong>Client report ready</strong>
            <p>Open items, owners, photos, and approvals compiled.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
